import React from "react";
import ReactDOM from "react-dom/client";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.3.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "../src/App.css";

import { store } from "store/store";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "store/store";

import "mdi-icons/css/materialdesignicons.min.css";
import AvantSolar from "routes/AvantSolar";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <AvantSolar></AvantSolar>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </HelmetProvider>
);
